<template>
  <modal id="export-received-referrals-modal">
    <template v-slot:header> Report Settings </template>
    <div>
      <div class="col-12 p-0 mb-3">
        <label class="col-12 font-weight-bold pt-2">Vendors</label>

        <select
          v-model="exportFilters.selectedVendor"
          @change="
            (exportFilters.selectedService = -1),
              (exportFilters.selectedLocation = -1)
          "
          class="form-control small-shadow-card"
        >
          <option :value="-1">Select a Vendor</option>
          <option
            v-for="vendor in vendorsForDropdown"
            :value="vendor.value"
            :key="vendor.value"
            :style="vendor.isArchived ? 'color: #e63757;' : ''"
          >
            {{ vendor.label }}
            <span v-if="vendor.isArchived">(Archived)</span>
          </option>
        </select>
      </div>
      <div class="col-12 p-0 mb-3">
        <label class="col-12 font-weight-bold pt-2">Services</label>
        <select
          v-model="exportFilters.selectedService"
          class="form-control small-shadow-card"
        >
          <option :value="-1">Select a Service</option>
          <option
            v-for="service in filteredServices"
            :value="service.value"
            :key="service.value"
          >
            {{ service.label }}
          </option>
        </select>
      </div>
      <div class="col-12 p-0 mb-3">
        <label class="col-12 font-weight-bold pt-2">Locations</label>
        <select
          v-model="exportFilters.selectedLocation"
          class="form-control small-shadow-card"
        >
          <option :value="-1">Select a Location</option>
          <option
            v-for="location in filteredLocations"
            :value="location.value"
            :key="location.value"
            :style="location.isArchived ? 'color: #e63757;' : ''"
          >
            {{ location.label }}
            <span v-if="location.isArchived">(Archived)</span>
          </option>
        </select>
      </div>
      <div class="col-12 p-0 mb-3">
        <label class="col-12 font-weight-bold pt-2">Status</label>

        <select
          v-model="exportFilters.selectedStatus"
          class="form-control small-shadow-card"
        >
          <option :value="-1">Select a Status</option>
          <option
            v-for="status in statuses"
            :value="status.value"
            :key="status.value"
          >
            {{ status.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="row border-bottom align-items-center">
      <label class="col-12 col-md-6 font-weight-bold py-2 mb-2"
        >Select report period</label
      >
      <div class="mt-2 pt-1 col-12">
        <v-date-picker
          v-model="exportFilters.range"
          mode="date"
          :masks="masks"
          is-range
        >
          <template v-slot="{ inputValue, inputEvents, isDragging }">
            <div
              class="d-flex justify-content-start align-items-center form-group"
            >
              <input
                class="px-2 py-1 form-control small-shadow-card"
                :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                :value="inputValue.start"
                v-on="inputEvents.start"
              />
              <div class="mx-4">-</div>
              <input
                class="px-2 py-1 form-control small-shadow-card"
                :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                :value="inputValue.end"
                v-on="inputEvents.end"
              />
            </div>
          </template>
        </v-date-picker>
        <div>
          <strong>Note:</strong> Creation period is required when generate a
          report
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-3 mr-3">
      <button
        @click="exportReceivedReferralsReport(exportFilters)"
        class="btn btn-primary btn-success mb-3 ml-3"
      >
        <span
          class="spinner-border spinner-border-sm"
          v-if="exportReceivedReferralsLoading"
        ></span>
        <span v-else> Export Referrals </span>
      </button>
    </div>
  </modal>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { myTimezone, adjustTimePeriod, formatLocation } from "@/utils/helpers";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default {
  props: {
    vendors: Array,
    statuses: Array,
  },
  data() {
    return {
      masks: {
        input: "YYYY-MM-DD",
      },
      exportFilters: {
        selectedService: -1,
        selectedVendor: -1,
        selectedStatus: -1,
        selectedLocation: -1,
        range: {
          start: new Date(),
          end: new Date(),
        },
      },
    };
  },
  computed: {
    ...mapState({
      exportReceivedReferralsLoading: (state) =>
        state.orders.exportReceivedReferralsLoading,
    }),
    filteredServices: function () {
      const vm = this;
      let services = [];
      if (this.exportFilters.selectedVendor != -1) {
        const vendor = this.vendors.find(
          (vendor) => vendor.id == vm.exportFilters.selectedVendor
        );
        if (vendor) {
          services = vendor.services;
        }
      } else {
        services = this.vendors
          .reduce(
            (mergedServices, vendor) => mergedServices.concat(vendor.services),
            []
          )
          .sort((a, b) => (a.name > b.name ? 1 : -1));
      }
      const uniqueArray = _.uniqBy(services, "id");
      return uniqueArray.map((service) => {
        return {
          value: service.id,
          label: service.name,
        };
      });
    },
    filteredLocations: function () {
      const vm = this;
      let locations = [];
      if (this.exportFilters.selectedVendor != -1) {
        const vendor = this.vendors.find(
          (userVendor) => userVendor.id == vm.exportFilters.selectedVendor
        );
        if (vendor) {
          locations = vendor.locations;
        }
      } else {
        locations = this.vendors.reduce(
          (mergedLocations, vendor) => mergedLocations.concat(vendor.locations),
          []
        );
      }
      const uniqueArray = _.uniqBy(locations, "id");
      let locationsForDropdown = uniqueArray
        .map((location) => {
          return {
            value: location.id,
            label: formatLocation(location),
            isArchived: location.is_archived ? true : false,
          };
        })
        .sort((a, b) => {
          return a.isArchived && !b.isArchived ? 1 : -1;
        });
      locationsForDropdown.push({
        value: "NOT_AVAILABLE",
        label: "Others (orders that do not specify a location, if any)",
      });
      return locationsForDropdown;
    },
    vendorsForDropdown: function () {
      return this.vendors
        .map((vendor) => {
          return {
            value: vendor.id,
            label: vendor.name,
            isArchived: vendor.is_archived ? true : false,
          };
        })
        .sort((a, b) => {
          return a.isArchived && !b.isArchived ? 1 : -1;
        });
    },
  },
  methods: {
    ...mapActions({
      exportReceivedReferrals: "orders/exportReceivedReferrals",
    }),
    exportReceivedReferralsReport: function (filters) {
      const vm = this;
      const modifiedDateRange = adjustTimePeriod(
        filters.range.start,
        filters.range.end
      );
      let payload = {
        timezone: myTimezone(),
        ...modifiedDateRange,
      };
      if (filters.selectedService != -1) {
        payload["service_id"] = filters.selectedService;
      }
      if (filters.selectedVendor != -1) {
        payload["vendor_id"] = filters.selectedVendor;
      }
      if (filters.selectedLocation != -1) {
        payload["location_id"] = filters.selectedLocation;
      }
      if (filters.selectedStatus != -1) {
        payload["status"] = filters.selectedStatus;
      }
      this.exportReceivedReferrals(payload).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "received_referrals_report.xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();
        vm.$store.dispatch("hideModal", "export-received-referrals-modal");
      });
    },
  },
};
</script>
